import cloudStore from "../../store/CloudStore";
import List from "@material-ui/core/List";
import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import NestedSidebar from "./NestedSideBar";
import CollectionMenuItem from "./CollectionMenuItem";
import NavigationMenuItem from "./NavigationMenuItem";
import withIntl from "../../utils/withIntl";
import CollectionLink from "../../utils/routes/CollectionLink";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import MenuIcon from "@material-ui/icons/Menu";
import Drawer from "@material-ui/core/Drawer";
import { smallScreenBoundary } from "../../containers/Dashboard";
import DashboardTopBar from "../DashboardTopBar/DashboardTopBar";
import { _get } from "../../Api";
import { setUserProfiles, setUserRoles } from "../../store/CloudActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getProfilesFromMerchant } from "../../authorization/authorizations";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  sidebarContainer: { position: "relative", height: "100vh", overflowX: "hidden" },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    marginLeft: 65,
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  toolbarIcon: {
    display: "flex",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    height: "100%",
    overflowY: "auto",
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {},
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 0, // theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  docked: {
    width: 0,
  },
}));

function DashboardSideMenu(props) {
  const classes = useStyles();
  const [smallScreen, setSmallScreen] = React.useState(window.innerWidth < smallScreenBoundary);
  const [drawerOpen, setDrawerOpen] = React.useState(!smallScreen);

  const [merchant] = React.useState(cloudStore.merchant);
  const [selectedCollectionMenuItem, setSelectedCollectionMenuItem] = React.useState(null);
  const [routes] = React.useState(props.routes);

  const [subDrawerOpen, setSubDrawerOpen] = React.useState(selectedCollectionMenuItem?.subLinks != null);
  const [loading, setLoading] = React.useState(true);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMouseLeave = () => {
    if (!smallScreen) {
      if (selectedCollectionMenuItem?.subLinks) {
        if (
          selectedCollectionMenuItem.subLinks.some((link) => {
            return link.match(props.location.pathname);
          })
        ) {
          if (!subDrawerOpen) {
            setSubDrawerOpen(true);
          } else {
            setSubDrawerOpen(true);
          }
        } else {
          let selected = routes.find((link) => {
            return link.match(props.location.pathname);
          });
          if (selected instanceof CollectionLink) {
            setSelectedCollectionMenuItem(selected);
          } else {
            setSubDrawerOpen(false);
          }
          if (!subDrawerOpen) {
            setSubDrawerOpen(true);
          }
        }
      }
    }
  };
  const goToSelect = () => {
    props.history.push("/select");
  };

  useEffect(() => {
    window.addEventListener("resize", () => {
      setSmallScreen(window.innerWidth < 620);
    });
  }, []);

  useEffect(() => {
    if (!cloudStore.userRoles) {
      const sessionRoles = JSON.parse(sessionStorage.getItem("roles"));
      if (!sessionRoles || sessionRoles.length === 0) {
        _get("/nova/api/roles")
          .then((res) => {
            let roles = [];
            res.data.data.roles.forEach((role) => {
              roles.push(role.name);
            });
            sessionStorage.setItem("roles", JSON.stringify(roles));
            setUserRoles(roles);
            setUserProfiles(getProfilesFromMerchant({}));
            setLoading(false);
          })
          .catch((e) => {
            console.log(e);
            setLoading(false);
          });
      } else {
        sessionStorage.setItem("roles", JSON.stringify(sessionRoles));
        setUserRoles(sessionRoles);
        setUserProfiles(getProfilesFromMerchant({}));
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  let name = "MynOber";
  if (window.whiteLabel === "jamezz") {
    name = "Jamezz";
  }

  return (
    <>
      <DashboardTopBar
        handleDrawerOpen={handleDrawerOpen}
        open={drawerOpen}
        id={merchant?.id}
        navigationRows={props.navigationRows}
      />
      <Drawer
        variant={smallScreen ? "temporary" : "persistent"}
        classes={{
          paper: clsx(classes.drawerPaper, !drawerOpen && classes.drawerPaperClose),
          docked: !drawerOpen ? classes.docked : null,
        }}
        open={drawerOpen}
      >
        <div className={classes.toolbarIcon}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            title={"Ga terug"}
            onClick={goToSelect}
            className={classes.selectButton}
          >
            <ChevronLeftIcon />
          </IconButton>

          <Typography variant="h6" color="inherit" noWrap className={classes.title}>
            {name} Cloud
          </Typography>

          <IconButton onClick={handleDrawerClose}>
            <MenuIcon />
          </IconButton>
        </div>
        <Divider />
        <div className={classes.sidebarContainer} onMouseLeave={handleMouseLeave}>
          <Divider />
          <List>
            {routes.map((link) => {
              if (link.subLinks) {
                return (
                  <CollectionMenuItem
                    key={link.getLink()}
                    link={link}
                    setOpen={handleDrawerOpen}
                    setSubDrawerOpen={setSubDrawerOpen}
                    onClick={() => {
                      if (subDrawerOpen) {
                        if (selectedCollectionMenuItem === link) {
                          setSubDrawerOpen(false);
                        } else {
                          setSubDrawerOpen(false);
                        }
                      } else {
                        if (selectedCollectionMenuItem === link) {
                          setSubDrawerOpen(true);
                        } else {
                          setSelectedCollectionMenuItem(link);
                          setSubDrawerOpen(true);
                        }
                      }
                    }}
                  />
                );
              } else {
                return (
                  <NavigationMenuItem
                    key={link.getLink()}
                    link={link}
                    onClick={(e) => {
                      if (smallScreen && subDrawerOpen) {
                        e.preventDefault();
                        setSubDrawerOpen(false);
                      } else {
                        if (smallScreen) {
                          setDrawerOpen(false);
                        }
                      }
                    }}
                    onMouseOver={() => {
                      if (!smallScreen) {
                        setSubDrawerOpen(false);
                      }
                    }}
                  />
                );
              }
            })}
          </List>
          <Divider />

          <NestedSidebar
            selectedLinkWithSubLinks={selectedCollectionMenuItem}
            smallScreen={smallScreen}
            setOpen={setDrawerOpen}
            setSubDrawerOpen={setSubDrawerOpen}
            subDrawerOpen={subDrawerOpen}
            dashboardMenuOpen={drawerOpen}
            navigationMenuItemSelected={() => {
              if (smallScreen && subDrawerOpen) {
                setSubDrawerOpen(false);
              }
              if (smallScreen) {
                setDrawerOpen(false);
              }
            }}
          />
        </div>
      </Drawer>
    </>
  );
}

export default withRouter(withIntl(DashboardSideMenu));
